/**
 * 图片预览插件
 */
import Vue from 'vue'
import ImagePreview from './ImagePreview'

let instance ;

var ImagePreviewConstruct = Vue.extend(ImagePreview)

instance = new ImagePreviewConstruct({
  el: document.createElement('div')
});
document.body.appendChild(instance.$el);

let ImagePreviewInit = (items) => {
  instance.showImgs(items);
}


export default {
  install (Vue) {
      Vue.prototype.$imagePreview = ImagePreviewInit;
  }
}



// WEBPACK FOOTER //
// ./src/components/imgPreview/index.js